export default {
  WHEN_CLICKED: 1,
  NEVER: 2,
};



// WEBPACK FOOTER //
// ./src/default-settings/compact-show-video-list.js